<script lang="ts" setup>
import type { PropType } from 'vue';

import { useService } from '@nzyme/vue-ioc/useService.js';
import { AuthStore } from '@sigma/client/auth/AuthStore.js';
import Avatar from '@sigma/ui/Avatar.vue';
import type { AvatarColor } from '@sigma/ui/Avatar.vue';

defineProps({
  color: {
    type: String as PropType<AvatarColor>,
    default: 'blue',
  },
});

const authStore = useService(AuthStore);
</script>

<template>
  <Avatar
    :color="color"
    :first-name="authStore.user?.firstName"
    :last-name="authStore.user?.lastName"
    :photo="authStore.user?.photo"
  />
</template>
